/**
 * @generated SignedSource<<bbdcd77ba7ed0c36396faab5ed11f6a8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Tile_kpiTileGraphRegions$data = {
  readonly negative: number;
  readonly positive: number;
  readonly " $fragmentType": "Tile_kpiTileGraphRegions";
};
export type Tile_kpiTileGraphRegions$key = {
  readonly " $data"?: Tile_kpiTileGraphRegions$data;
  readonly " $fragmentSpreads": FragmentRefs<"Tile_kpiTileGraphRegions">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Tile_kpiTileGraphRegions",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "negative",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "positive",
      "storageKey": null
    }
  ],
  "type": "WidgetKPITileGraphRegions",
  "abstractKey": null
};

(node as any).hash = "77b2d37ab120c772c59e2c91c771cba4";

export default node;
